module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notes-drawer"
  }, [_c('div', {
    staticClass: "notes-tray-header"
  }, [_c('img', {
    staticClass: "notes-icon",
    attrs: {
      "src": require("../assets/icons/notes_selected.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "notes-title"
  }, [_vm._v(_vm._s(_vm.$t('str.Notes')))]), _vm._v(" "), _c('div', {
    staticClass: "notes-buttons"
  }, [_c('transition-group', {
    attrs: {
      "name": "wave"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDirty === false),
      expression: "isDirty === false"
    }],
    key: 1,
    staticClass: "autosaving",
    attrs: {
      "contenteditable": "false"
    }
  }, [_vm._v("s")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDirty === false),
      expression: "isDirty === false"
    }],
    key: 2,
    staticClass: "autosaving",
    attrs: {
      "contenteditable": "false"
    }
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDirty === false),
      expression: "isDirty === false"
    }],
    key: 3,
    staticClass: "autosaving",
    attrs: {
      "contenteditable": "false"
    }
  }, [_vm._v("v")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDirty === false),
      expression: "isDirty === false"
    }],
    key: 4,
    staticClass: "autosaving",
    attrs: {
      "contenteditable": "false"
    }
  }, [_vm._v("e")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDirty === false),
      expression: "isDirty === false"
    }],
    key: 5,
    staticClass: "autosaving",
    attrs: {
      "contenteditable": "false"
    }
  }, [_vm._v("d")])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "title": _vm.$t('str.emailNotes')
    },
    on: {
      "click": _vm.emailNotes
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "title": _vm.$t('str.copyToClipboard')
    },
    on: {
      "click": _vm.copyToClipboard
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })]), _vm._v(" "), _c('a', {
    staticClass: "notes-btn-right",
    attrs: {
      "title": _vm.$t('str.Close')
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "notes-body"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userNotes),
      expression: "userNotes"
    }],
    staticClass: "note-content",
    attrs: {
      "name": "user-notes",
      "placeholder": _vm.$t('str.MyPrivateNote')
    },
    domProps: {
      "value": (_vm.userNotes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userNotes = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "notes-arrow"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c183a742","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotesTray.vue
// module id = 491
// module chunks = 0